import { render } from "./DetailTabs.vue?vue&type=template&id=504162c8&scoped=true"
import script from "./DetailTabs.vue?vue&type=script&lang=js"
export * from "./DetailTabs.vue?vue&type=script&lang=js"

import "./DetailTabs.vue?vue&type=style&index=0&id=504162c8&lang=scss&scoped=true"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504162c8"],['__file',"DetailTabs.vue"]])

export default __exports__